/* import __COLOCATED_TEMPLATE__ from './legacy-feature-callout.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();